/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Dashboard_SubtitleInputs */

const vi_warehouse_sales_dashboard_subtitle = /** @type {(inputs: Warehouse_Sales_Dashboard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi tồn, biến động và cảnh báo trong kỳ.`)
};

/**

* @param {Warehouse_Sales_Dashboard_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_dashboard_subtitle = /** @type {((inputs?: Warehouse_Sales_Dashboard_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Dashboard_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_dashboard_subtitle(inputs)
});